import { MenuConfig } from 'commonTypes'

const menuConfig: Array<MenuConfig> = [
    {
        id: 'compounds',
        show: true,
        name: 'Compounds',
        iconSrc: 'assets/icons/menu/compounds-icon.svg',
        route: '/compounds',
        subMenu: [],
        scrollTo: ''
    },
    {
        id: 'targets',
        show: true,
        name: 'Targets',
        iconSrc: 'assets/icons/menu/sample-icon.svg',
        route: '/targets',
        subMenu: [],
        scrollTo: ''
    },
    {
        id: 'alterations',
        show: true,
        name: 'Alterations detected',
        iconSrc: 'assets/icons/menu/sample-icon.svg',
        route: '/drivers',
        subMenu: [],
        scrollTo: ''
    }
]

export default menuConfig
